import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { telaInicialDoUsuario } from '@core/constants/tela-inicial';
import { LogoComponent } from '@core/layout/components/logo/logo.component';
import { UsuariosService } from '@modules/usuarios/services/usuarios.service';
import { IconComponent } from '@shared/components/icon/icon.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';

@Component({
  selector: 'app-acesso-negado',
  imports: [IconComponent, LogoComponent, ReactiveFormsModule, AppButtonDirective],
  templateUrl: 'acesso-negado.component.html',
  styles: [],
})
export class AcessoNegadoComponent {
  private readonly _router = inject(Router);
  private readonly _usuarios = inject(UsuariosService);

  /**
   * Volta para a tela inicial do usuário. Ir para `/` mandava para o login, que devolvia para
   * `/planilhas`: quem não tem essa listagem (o fiscal) voltava para cá, num laço sem saída (#733).
   */
  onBack() {
    this._router.navigateByUrl(telaInicialDoUsuario(this._usuarios.usuarioLogado), { replaceUrl: true });
  }
}
